import React, { useEffect, useMemo, useRef, useState } from 'react';
import { categoryList, menuItemList, menuItemDetail } from '../services/menu.service';
import Skeleton from 'react-loading-skeleton';
import { CONSUMPTION_TAX_RATES, CURRENCY_SYMBOL, LOADER_TIMEOUT_TIME } from '../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from "formik";
import { capitalizeFirstLetter, generatePreferencesId, getAddonPrice, getSessionKey, getSubTotalQRApp, getTranslatedKey, pluralText, selectAddon, showPrice } from '../../../utils/commonfunction';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RecordNotFound from '../../restaurant/shared/recordNotFound';
import { SetCartLength } from '../../../redux/slices/qrcodeDetails';

export default function AddMenu() {
  const queryParams = new URLSearchParams(window.location.search);
  const [token, setToken] = useState(getSessionKey("qr_user_token"));
  const [categoriesList, setCategoriesList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [catLoader, setCatLoader] = useState(true);
  const [itemLoader, setItemLoader] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(queryParams.get('category_id') || '');
  const [currentItem, setCurrentItem] = useState({});
  const addFormCloseButton = useRef();
  const addFormOpenButton = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [langChanged, setLangChanged] = useState(false);
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = useState([...(JSON.parse(sessionStorage.getItem("cartItem")) || [])]);
  const [customerDetails, setCustomerDetails] = useState(location?.state?.customerDetails || null);
  const CartLengthData = useSelector((state) => state.QrOrderToken.CartLength);
  const dispatch = useDispatch();
  const base = queryParams.get('base');
  const ChargeSettings = useSelector((state) => {
    return state.QrOrderToken.ChargeSettings;
  });
  const [removableItems, setRemovableItems] = useState([]);
  const removableItemsOpenButton = useRef();
  const removableItemsCloseButton = useRef();
  const newToken = useSelector((state) => { return state.QrOrderToken.qrPanelToken });

  useEffect(() => {
    setToken(newToken);
  }, [newToken]);

  const addForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      _id: '',
      type: '',
      image: '',
      item_name: '',
      addons: [],
      price: '',
      tax_price: '',
      total_price: '',
      short_description: '',
      consumption_tax_rate: '',
      cost_price: '',
      upselling_items: [],
    },
    onSubmit: (values) => {
      const preferenceId = generatePreferencesId(values);
      const addonPrice = getAddonPrice(values);

      const data = selectedItems.map((item) => {
        if (item.preference_id === preferenceId) {
          return {
            ...item,
            quantity: item.quantity + 1,
          };
        }
        return item;
      });

      const isAlreadyAdded = selectedItems.some(
        (item) => item.preference_id === preferenceId
      );

      const finalItems = isAlreadyAdded
        ? data
        : [
            ...selectedItems,
            {
              ...values,
              quantity: 1,
              preference_id: preferenceId,
              addon_price: addonPrice,
            },
          ];

      setSelectedItems(finalItems);
      sessionStorage.setItem("cartItem", JSON.stringify(finalItems));

      addFormCloseButton?.current?.click();
      addForm.resetForm();
    },

  });

  useEffect(() => {
    if (token && token.length) {
      setCatLoader(true);
      categoryList({}, { token: token })
        .then((response) => {
          setCategoriesList(response.data.list);
          if (!selectedCategory) {
            setSelectedCategory(response.data.list[0]?._id);
          }
          setTimeout(() => {
            setCatLoader(false);
            const appData = { action: 'stop-loader', data: {} };
            window.ReactNativeWebView?.postMessage(JSON.stringify(appData));
          }, LOADER_TIMEOUT_TIME);
        })
        .catch((err) => { console.error(err) });
    }
  }, [token, langChanged]);


  // Fetch menu items when category changes
  useEffect(() => {
    if (token && token.length) {
      setItemLoader(true);
      let filterCategory = {};
      if (selectedCategory) {
        filterCategory.category_id = selectedCategory;
      }
      menuItemList(filterCategory, { token: token })
        .then((response) => {
          setItemList(response?.data?.list);
          setTimeout(() => { setItemLoader(false) }, LOADER_TIMEOUT_TIME)
        })
        .catch((err) => { console.error(err) });
    }
  }, [token, selectedCategory, langChanged]);

  const fetchMenuItemDetail = (item, shouldFind = true) => {
    return new Promise(async (resolve, reject) => {
      let response = { data: item };
      if (shouldFind) {
        response = await menuItemDetail({ o_id: item._id }, { token: token });
      }
      if (item.addons?.length) {
        let data = {
          ...response?.data,
          addons: response?.data?.addons
        };
        // console.log("datadatadata", data);
        addForm.setValues(data);
        // setCurrentItem(data);
        setTimeout(() => {
          resolve(response);
        }, 100);
        addFormOpenButton?.current?.click();
      } else {
        let data = [...selectedItems];
        const index = data.findIndex((record) => record?._id === item?._id);
        if (index !== -1) {
          data[index].quantity += 1;
        } else {
          const newItem = { ...item, quantity: 1, preference_id: generatePreferencesId(item), addon_price: getAddonPrice(item) };
          data.push(newItem);
        }
        setSelectedItems(data);
        sessionStorage.setItem("cartItem", JSON.stringify(data));
      }
    })
  }

  useEffect(() => {
    let result = 0;
    selectedItems.forEach((record) => {
      result += record?.quantity;
    });
    dispatch(SetCartLength(result));
  }, [selectedItems]);

  useMemo(() => {
    document.addEventListener('language_change', function () {
      setLangChanged(!langChanged);
    })
  });

  const isItemSelected = (item) => {
    return selectedItems?.findIndex(record => record?._id === item?._id) !== -1;
  };

  const getCurrentQuantity = (item) => {
    let result = 0;
    const records = selectedItems?.filter(record => record?._id === item?._id);
    records.forEach((record) => {
      result += record?.quantity;
    });
    return result;
  };

  const handleChangeQuantity = (item, type) => {
    let allItems = [...selectedItems];
    if (type === "increase") {
      fetchMenuItemDetail(item, false);
    } else {
      const commonItems = allItems.filter((record) => record?._id === item?._id);
      if (commonItems.length > 1) {
        setRemovableItems(commonItems);
        removableItemsOpenButton?.current?.click();
      } else {
        const index = allItems.findIndex((record) => record?._id === item?._id);
        if (allItems[index]?.quantity > 1) {
          allItems[index].quantity -= 1;
        } else {
          allItems.splice(index, 1);
        }
      }
      sessionStorage.setItem("cartItem", JSON.stringify(allItems));
      setSelectedItems(allItems);
    }

  };

  const handleQuantityChangeOfUpsellingItem = (item, type) => {
    let allItems = [...selectedItems];
    const existingIndex = allItems.findIndex(record => record?._id === item?._id);
    if (type === "increase") {
      if (existingIndex !== -1) {
        allItems[existingIndex].quantity += 1;
      } else {
        const newItem = { ...item, quantity: 1, preference_id: generatePreferencesId(item) };
        allItems.push(newItem);
      }
    } else if (type === "decrease") {
      const commonItems = allItems.filter((record) => record?._id === item?._id);
      if (commonItems.length > 1) {
        setRemovableItems(commonItems);
      } else {
        if (existingIndex !== -1) {
          if (allItems[existingIndex]?.quantity > 1) {
            allItems[existingIndex].quantity -= 1;
          } else {
            allItems.splice(existingIndex, 1);
          }
        }
      }
    }
    sessionStorage.setItem("cartItem", JSON.stringify(allItems))
    setSelectedItems(allItems);
  }

  const deleteSubQuantity = (item) => {
    let primaryItems = [...selectedItems];
    let tempItems = [...removableItems];
    const primaryIndex = primaryItems.findIndex((record) => record?.preference_id === item?.preference_id);
    const secondaryIndex = tempItems.findIndex((record) => record?.preference_id === item?.preference_id);
    if (item.quantity > 1) {
      primaryItems[primaryIndex].quantity -= 1;
    } else {
      if (primaryIndex !== -1) {
        primaryItems.splice(primaryIndex, 1);
      }
      if (secondaryIndex !== -1) {
        tempItems.splice(secondaryIndex, 1);
      }
    }
    setRemovableItems(tempItems);
    setSelectedItems(primaryItems);
    sessionStorage.setItem("cartItem", JSON.stringify(primaryItems))
    if (tempItems.length === 0) {
      removableItemsCloseButton?.current?.click();
    }
  };
  const addSubItem = (item) => {
    const preferenceId = generatePreferencesId(item);

    const updated = selectedItems.map((existingItem) => {
      if (existingItem.preference_id === preferenceId) {
        return {
          ...existingItem,
          quantity: existingItem.quantity + 1,
        };
      }
      return existingItem;
    });

    const isAlreadyAdded = selectedItems.some(
      (existingItem) => existingItem.preference_id === preferenceId
    );

    const finalItems = isAlreadyAdded
      ? updated
      : [
          ...selectedItems,
          {
            ...item,
            quantity: 1,
            addon_price: 0,
            preference_id: preferenceId,
          },
        ];

    setSelectedItems(finalItems);
    sessionStorage.setItem("cartItem", JSON.stringify(finalItems));
  };


  const handleAsterisk = (item) => {
    let result = null;
    if (
      item?.consumption_tax_rate === CONSUMPTION_TAX_RATES.TAKE_OUT &&
      ChargeSettings?.icon_display_eligible_for_reduced_tax_rate
    ) {
      result = <span className="fw-bold">*</span>;
    }
    return result;
  };

  function menuItemSelected() {
    const searchParams = window.location.search;
    navigate(`/qr-order/review${searchParams}`, {
      state: { selectedItems: selectedItems, customerDetails: customerDetails },
    });
  }

  return (
    <>
      <div className="qr-body-wrap">
        <div className="menu-qr-main-wrap">
          <div className="qr-menu-left">
            {!catLoader ? (
              <div className="qr-menu-list">
                {categoriesList.length > 0
                  ? categoriesList.map((item, index) => {
                    return (
                      <button
                        className={"menu-btn" + (selectedCategory === item._id ? ` active` : "")}
                        key={index}
                        onClick={() => {
                          setSelectedCategory(item?._id);
                          const searchParams = new URLSearchParams(window.location.search);
                          searchParams.set("category_id", item?._id);
                          navigate({
                            pathname: location.pathname,
                            search: searchParams.toString(),
                          });
                        }}
                      >
                        <div className="card upsell-card ">
                          <img src={item?.image} alt={item?.name} />
                        </div>
                        {getTranslatedKey('name', item)}{" "}
                        {/* {TrimText(getTranslatedKey('name', item), 8)}{" "} */}
                      </button>
                    );
                  })
                  : ""}
              </div>
            ) : (
              <div className="qr-menu-list">
                <Skeleton style={{ height: "37px" }} />
                <Skeleton style={{ height: "37px" }} />
                <Skeleton style={{ height: "37px" }} />
                <Skeleton style={{ height: "37px" }} />
                <Skeleton style={{ height: "37px" }} />
              </div>
            )}
          </div>
          {/* Main menu items list */}
          <div className="qr-menu-right">
            {!itemLoader ? (
              <>
                {itemList.length ? (
                  <div className="qr-menu-item-list">
                    {itemList.map((item, index) => {
                      return (
                        <div className={"qr-menu-item-col" + (isItemSelected(item) ? " item-selected" : "")} key={index}>
                          <figure>
                            <img src={item?.image} alt={item?.item_name} />
                          </figure>
                          <figcaption>
                            <div>
                              <span className='item-name'>{item?.item_name}</span>
                              <span>{CURRENCY_SYMBOL} {showPrice(item?.price)}</span>
                            </div>

                            {isItemSelected(item) ?

                              <div className="border border-1 rounded-1 mb-2 quantity-box d-flex justify-content-between">
                                <button className="btn btn-sm py-1 px-2 h-auto" type="button" onClick={() => {
                                  handleChangeQuantity(item, "decrease");
                                }}
                                > <i className="ti ti-minus"></i>
                                </button>

                                <span className="d-flex align-items-center">
                                  {getCurrentQuantity(item)}
                                </span>

                                <button
                                  className="btn btn-sm py-1 px-2 h-auto"
                                  type="button"
                                  onClick={() => {
                                    handleChangeQuantity(item, "increase");
                                  }}
                                >
                                  <i className="ti ti-plus"></i>
                                </button>
                              </div>
                              :
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  fetchMenuItemDetail(item, false);
                                }}
                              > {t("Add")}
                              </button>
                            }
                          </figcaption>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="">
                    <RecordNotFound heading={t("qr_code.no_assigned_item_text")} />
                  </div>
                )}
              </>
            ) : (
              <div className="qr-menu-item-list">
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
                <div className="qr-menu-item-col">
                  <Skeleton style={{ height: "70px" }} className="rounded-3 mb-3" />
                  <figcaption>
                    <Skeleton containerClassName="d-flex" />
                    <Skeleton containerClassName="d-flex" inline={true} style={{ height: "10px" }} />
                    <Skeleton containerClassName="d-flex" style={{ height: "33px" }} />
                  </figcaption>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {CartLengthData ? (
        <div className="cart-bottom p-3">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <span className='d-flex align-items-center justify-content-between w-100 body-14'>
              {CartLengthData} {pluralText(CartLengthData, t("Item"), t("Items"))}
              <span className='ms-4'>{CURRENCY_SYMBOL} {showPrice(getSubTotalQRApp(selectedItems)?.subtotal)}</span>
            </span>
          </div>
          <button
            className="btn btn-primary w-100"
            onClick={menuItemSelected}
          >
            Review and Place Order
          </button>
        </div>
      ) : null}

      <button className="btn btn-sm btn-primary d-none" ref={addFormOpenButton} data-bs-toggle="offcanvas" data-bs-target="#itemModifyCanvas" aria-controls="itemModifyCanvas"></button>
      <div className="offcanvas offcanvas-bottom qr-offcanvas canvas-radius overflow-hidden" data-bs-backdrop="static" tabIndex="-1" id="itemModifyCanvas" aria-labelledby="itemModifyCanvasLabel">
        <div className="offcanvas-header pb-0">
          <h3 className="offcanvas-title" id="itemModifyCanvasLabel">
            {getTranslatedKey('item_name', addForm?.values)}
          </h3>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            ref={addFormCloseButton}
            onClick={() => {
              const searchParams = new URLSearchParams(window.location.search);
              searchParams.delete("openEdit");
              navigate({
                pathname: location.pathname,
                search: searchParams.toString(),
              });
            }}
          ></button>
        </div>

        <div className="offcanvas-body small">
          {addForm?.values?.short_description && <p className="mb-4" style={{ fontSize: '14px' }}>{addForm.values.short_description}</p>}
          <form onSubmit={addForm.handleSubmit}>
            {addForm?.values?._id && (
              <>
                {/* <div className="card card-2"> */}
                <div className="">
                  {/* Add-on sections */}
                  {addForm?.values?.addons?.length > 0 ? addForm.values.addons.map((addon, index) => {
                    return (
                      <div key={index} className={(index + 1 < addForm?.values?.addons?.length ? "mb-4" : "")}>
                        <h3 className="mb-2">
                          {getTranslatedKey("addon_name", addon)}
                        </h3>
                        <div className="d-flex flex-wrap gap-2">
                          {/* Actual options */}
                          {addon?.assigned_items?.map((option, opIndex) => {
                            return (
                              <label htmlFor={option?._id} className='item-type-checkbox' key={opIndex}>
                                <input id={option?._id} name={addon?.addon_id} type="radio" checked={option?.selected} onChange={() => { selectAddon(addForm, addon, option) }} value={option._id} />
                                <span className='label'>
                                  {capitalizeFirstLetter(option.item_name)} {option?.item_price > 0 ? ` + ${CURRENCY_SYMBOL} ${option?.item_price}` : ""}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }) : null}


                  {/* Up-selling items */}
                  {addForm?.values?.upselling_items?.length > 0 && (
                    <>
                      <div className='upselling-items-wrap mt-4'>
                        <h3 className="mb-3">Would you like to have more?</h3>
                        <div className="d-flex upselling-item-wrapper pb-4">
                          {addForm?.values?.upselling_items?.map((item, i) => (

                            <div key={i} className="card upsell-card text-center p-2" style={{ maxWidth: "190px", maxHeight: "190px", height: "auto", overflowY: "auto", minWidth: "160px" }}>
                              <figure style={{ width: "100%", overflow: "hidden", borderRadius: "10px", marginBottom: "5px" }}>
                                <img style={{ objectFit: 'cover', objectPosition: 'center', width: '100%' }} src={item?.image} alt={item?.item_name} className="item-image mb-2" />
                              </figure>
                              <div>
                                <h5 className="mb-1">{capitalizeFirstLetter(item?.item_name)}</h5>
                                <p className="text-muted">{CURRENCY_SYMBOL} {showPrice(item?.price)}</p>
                              </div>

                              {isItemSelected(item) ? (
                                <div className="border border-1 rounded-1 mb-2 quantity-box d-flex justify-content-between">
                                  <button className="btn btn-sm py-1 px-2 h-auto" type="button" onClick={() => {
                                    handleQuantityChangeOfUpsellingItem(item, "decrease", getCurrentQuantity(item));
                                  }}
                                  > <i className="ti ti-minus"></i>
                                  </button>

                                  <span className="d-flex align-items-center">
                                    {getCurrentQuantity(item)}
                                  </span>

                                  <button
                                    className="btn btn-sm py-1 px-2 h-auto"
                                    type="button"
                                    onClick={() => {
                                      handleQuantityChangeOfUpsellingItem(item, "increase", getCurrentQuantity(item));
                                    }}
                                  >
                                    <i className="ti ti-plus"></i>
                                  </button>
                                </div>
                              ) : (
                                <button type='button' style={{ height: '30px', maxHeight: '30px', minHeight: '30px' }} className="btn btn-sm btn-primary s"
                                  onClick={() => { addSubItem(item) }}>{t("Add")}
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* </div> */}
              </>
            )}

            <button className="btn btn-primary w-100 mt-4" type="submit">
              {isItemSelected(addForm?.values) ? t("Update") : t("Add")}
            </button>
          </form>
        </div>

      </div>

      <button
        className="btn btn-dark w-100 mt-2 d-none"
        data-bs-toggle="modal"
        data-bs-target="#removeItemsOptions"
        ref={removableItemsOpenButton}
      ></button>
      <div
        className="modal fade qr-modal"
        id="removeItemsOptions"
        tabIndex="-1"
        aria-labelledby="removeItemsOptionsLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="exampleModalLabel">Remove Items</h2>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={removableItemsCloseButton}></button>
            </div>
            <div className="modal-body">
              <h3>Items</h3>
              <div className="d-flex gap-2 flex-column">
                {removableItems?.map(
                  (item, index) => {
                    return (
                      <div className="card card-2 mt-2" key={index}>
                        <div className="p-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="">
                              <span className="d-block">
                                {getTranslatedKey("item_name", item)}{" "}
                                {handleAsterisk(item)}{" "}
                                {item?.quantity > 1 ? (
                                  <strong>{`(x${item?.quantity})`}</strong>
                                ) : null}
                                <br />
                              </span>
                              {
                                item?.selectedAddons?.length ?
                                  <div className="modifiers-view">
                                    <span className="d-block text-primary">Selected modifiers</span>
                                    {
                                      item?.selectedAddons?.map((addon, index) => {
                                        return <span className="d-block" key={index}>{addon?.assigned_items[0]?.item_name}</span>;
                                      })
                                    }
                                  </div>
                                  : null
                              }
                              <span>
                                {CURRENCY_SYMBOL} {showPrice((item?.price + (item?.addon_price || 0)) * item?.quantity)}
                              </span>
                            </div>
                            <div>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-danger btn-sm px-2"
                                  type="button"
                                  onClick={() => {
                                    deleteSubQuantity(item);
                                  }}
                                >
                                  <i className="ti ti-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}